import { useContext } from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import NewProjectDialog from './NewProjectDialog';
import DeleteProjectDialog from './DeleteProjectDialog';
import AdminLayout from '../../../components/AdminLayout';
import AdminProjectsSnackbar from './Snackbar';
import { ProjectsContext } from './ProjectsContext';
import ProjectsGrid from './ProjectsGrid';

const AdminProjectsPage = () => {
    const { handleOpenDialog } = useContext(ProjectsContext);

    return (
        <AdminLayout>
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 4,
                    }}
                >
                    <Typography variant="h4" component="h1">
                        Manage Projects
                    </Typography>
                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => handleOpenDialog()}
                        >
                            Add Project
                        </Button>
                    </Box>
                </Box>

                <Paper sx={{ width: '100%', p: 2 }}>
                    <ProjectsGrid />
                </Paper>

                {/* Add/Edit Project Dialog */}
                <NewProjectDialog />
                {/* Delete Confirmation Dialog */}
                <DeleteProjectDialog/>
                {/* Snackbar for notifications */}
                <AdminProjectsSnackbar />
            </Container>
        </AdminLayout>
    );
};

export default AdminProjectsPage;
